
/**
 * AppViewReceiverModel
 *
 * レシーバーに送るデータ構造モデル
 * UI,継承、バインディング、処理名称でDispatchするために使用される
 */
export class AppViewReceiverModel {

	// 使用用途：レシーバーUtilでディスパッチするために使用される
	// イベントの発生元でAppViewReceiverConstの各区分の定義が設定される

	// UI区分の定義値を設定するプロパティ
	public ui: any; // AppViewReceiverConstのUI区分

	// 実体処理のクラス名称をいれる必要がある
	// メソッドが存在するクラスの名称
	public className: any;	// AppViewReceiverConstのクラス名区分

	// 処理名称の定義値を設定するプロパティ
	public methodName: any; // AppViewReceiverConstの処理名称区分

	// イベント元のインスンタンスを設定するプロパティ
	public instance: any;

	// コンストラクタ
	constructor(ui: any, className: any, methodName: any, instance: any) {
		this.ui = ui;
		this.className = className;
		this.methodName = methodName;
		this.instance = instance;
	}


}
